import { render, staticRenderFns } from "./trips.vue?vue&type=template&id=3ae156a6"
import script from "./trips.vue?vue&type=script&lang=js"
export * from "./trips.vue?vue&type=script&lang=js"
import style0 from "./trips.vue?vue&type=style&index=0&id=3ae156a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports